import type { Tint } from '@/types'

/** Soft washes for recessed picture panes, one per tint. */
export const tintClass: Record<Tint, string> = {
    blush: 'bg-[radial-gradient(ellipse_at_30%_20%,#dde8f4,#c2d6ec_75%)]',
    cool: 'bg-[radial-gradient(ellipse_at_30%_20%,#e9e8e4,#dad8d2_75%)]',
    sand: 'bg-[radial-gradient(ellipse_at_30%_20%,#f1e4cf,#e3d0b0_75%)]',
    sage: 'bg-[radial-gradient(ellipse_at_30%_20%,#e3e7da,#cfd8c4_75%)]',
    lilac: 'bg-[radial-gradient(ellipse_at_30%_20%,#ebe4ef,#d8cee0_75%)]'
}

export const TINTS: Tint[] = ['blush', 'sand', 'sage', 'lilac', 'cool']
